module.exports = __webpack_public_path__ + "assets/img/social_security_details.19fe64b8.jpg";